module.exports = __webpack_public_path__ + "static/media/bank-door-font-primary.eaa06dc2.png";